<template>
  <div
    :class="{ 'vue-select-container': true, 'vue-select-container-disabled': disabled }"
    :style="{ width: design.width }"
  >
    <select
      :disabled="disabled"
      :value="data.value"
      @change="valuechange($event.target.value)"
      :class="{ wide: !!design.wide }"
    >
      <template v-if="Array.isArray(data.text)">
        <template v-for="(elem, index) in data.data">
          <option v-if="elem != data.value" :value="elem" :key="guid + '_' + index">
            {{ data.text[index] }}
          </option>
          <option v-else selected :value="elem" :key="guid + '_' + index">
            {{ data.text[index] }}
          </option>
        </template>
      </template>
      <template v-else>
        <template v-for="(elem, index) in data.data">
          <option v-if="elem != data.value" :value="elem" :key="guid + '_' + index">
            {{ data.text[elem] }}
          </option>
          <option v-else selected :value="elem" :key="guid + '_' + index">
            {{ data.text[elem] }}
          </option>
        </template>
      </template>
    </select>
    <div
      :class="{
        'vue-select-text-container': true,
        'vue-select-text-container-disabled': disabled,
        wide: !!design.wide,
      }"
    >
      <span
        v-if="Array.isArray(data.text)"
        :class="{ 'vue-select-text-span': true, bold: !!design.bold, left: !!design.left, wide: !!design.wide }"
        >{{ data.text[get_value_index] }}</span
      >
      <span
        v-else
        :class="{ 'vue-select-text-span': true, bold: !!design.bold, left: !!design.left, wide: !!design.wide }"
        >{{ data.text[data.value] }}</span
      >
      <span :class="{ wide: !!design.wide }">{{ unit }}</span>
    </div>
    <svg
      v-if="!!design.wide"
      class="wide"
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 58.8 43.7"
      style="enable-background: new 0 0 58.8 43.7;"
      xml:space="preserve"
      :style="{ color: disabled ? design.color_disabled : design.color }"
    >
      <polygon id="XMLID_991_" fill="currentColor" class="st0" points="85.2,0 42.6,43.7 0,0" />
    </svg>
    <svg
      v-else
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 58.8 43.7"
      style="enable-background: new 0 0 58.8 43.7;"
      xml:space="preserve"
      :style="{ color: disabled ? design.color_disabled : design.color }"
    >
      <polygon id="XMLID_991_" fill="currentColor" points="58.8,0 29.4,43.7 0,0 "></polygon>
    </svg>
  </div>
</template>

<style lang="scss" scoped>
.vue-select-container {
  height: 100%;
  position: relative;

  select.wide {
    border-radius: 4.4rem;
  }

  svg {
    position: absolute;
    right: 0.8rem;
    width: 2rem;
    height: 1.2rem;
    top: calc(50% - 0.6rem);
    pointer-events: none;

    &.wide {
      right: 1.2rem;
      width: 3rem;
    }
  }

  &.vue-select-container-disabled {
    svg {
      right: 0.7rem;

      &.wide {
        right: 1.2rem;
      }
    }
  }
}

.vue-select-text-container {
  // border: 1px solid rgb(169, 169, 169);
  border: none;
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  border-radius: 1.75rem;
  background-color: white;
  pointer-events: none;
  display: flex;
  align-items: baseline;
  white-space: nowrap;
  text-align: right;
  padding-right: 3rem;
  padding-top: 0.6rem;

  &.wide {
    padding-right: 4.4rem;
    padding-bottom: 0.6rem;
    align-items: center;
    border-radius: 2.35rem;
    font-family: F-Dem;
  }

  &.vue-select-text-container-disabled {
    font-family: F-Std;
    color: $text_light;

    &.wide {
      color: $main_header_middle;
      background-color: $main_header_middle;
    }
  }

  span {
    text-overflow: ellipsis;
    overflow: hidden;
    pointer-events: none;
  }

  span:last-child {
    font-size: 0.8em;

    &.wide {
      font-size: inherit;
      padding-left: 0.4rem;
    }
  }
}

.vue-select-text-span {
  margin-left: auto;

  &.bold {
    font-weight: bold;
  }

  &.left {
    text-align: left;
    margin-left: 1rem;

    &.wide {
      margin-left: 2rem;
    }
  }
}

select {
  height: 100%;
  width: 100%;
  border-radius: 1.75rem;
  outline: none;
  border: none;
  background-image: none !important;
}
</style>

<script>
import calc from "../lib/helpers.js";

export default {
  name: "vue-select",
  props: ["design", "data", "unit", "disabled"],
  data: function () {
    return {
      guid: calc.generate_guid(),
    };
  },
  computed: {
    get_value_index: function () {
      if (this.data.isInteger === true) {
        return this.data.data.findIndex(function (elem) {
          // Treba nam zaokruzivanje, zato sto 7 !== 7.0000000000001, sto kvari prikaz odabranog broja
          return elem.toString() === Math.round(this.data.value).toString();
        }, this);
      } else {
        return this.data.data.findIndex(function (elem) {
          return elem.toString() === this.data.value.toString();
        }, this);
      }
    },
  },
  methods: {
    valuechange: function (value) {
      this.$emit("vue-select-change", value);
    },
  },
};
</script>
